import randomColor from 'randomcolor'

export function generateRandomColor(opts) {
  return randomColor(opts)
}

export function generateRandomColorForUser(userId) {
  return generateRandomColor({
    seed: userId,
    luminosity: 'dark',
  })
}

export function getFontColor(hex) {
  const [r, g, b] = hexToRgb(hex)

  if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
    return '#000000'
  }
  return '#FFFFFF'
}

export function hexToRgb(hex) {
  // Ensure hex is in 'FFFFFF' format
  hex = hex
    .replace('#', '')
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => r + r + g + g + b + b)

  return hex.match(/.{2}/g).map((x) => parseInt(x, 16))
}

export function isLightColor(hex) {
  const [r, g, b] = hexToRgb(hex)

  if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
    return true
  }
  return false
}

// The Aryeo purple every company starts with before setting its own brand color.
export const DEFAULT_BRAND_COLOR = '#4f46e5'

// The color the 'black' branding token renders as.
export const BLACK_BRANDING_COLOR = '#111116'

// Pass treatDefaultAsCustom to render the default brand color as if it were a custom one.
export function resolveBrandingColorTokenWithCustom(
  token,
  customColor,
  brandingPrimaryColor,
  treatDefaultAsCustom = false
) {
  if (token === 'black') {
    return BLACK_BRANDING_COLOR
  }

  if (token === 'white') {
    return '#FFFFFF'
  }

  if (token === 'custom') {
    return customColor || '#FFFFFF'
  }

  if (!treatDefaultAsCustom && brandingPrimaryColor?.toLowerCase() === DEFAULT_BRAND_COLOR) {
    return '#FFFFFF'
  }

  return brandingPrimaryColor
}

// The order form header color, from the company's settings or the form's own, depending on
// use_company_brand_settings.
export function resolveOrderFormHeaderColor(orderForm) {
  const useCompany = orderForm.use_company_brand_settings
  const token = useCompany
    ? orderForm.company.branding_order_form_header_color
    : orderForm.branding_header_color
  const custom = useCompany
    ? orderForm.company.branding_order_form_header_color_custom
    : orderForm.branding_header_color_custom

  return resolveBrandingColorTokenWithCustom(
    token,
    custom,
    orderForm.company.branding_primary_color
  )
}

// Swaps a missing color, or one with under 3:1 contrast against white (the WCAG minimum for UI
// indicators), for black so it stays visible on a white surface.
export function visibleOnWhite(hex) {
  if (!hex) {
    return BLACK_BRANDING_COLOR
  }

  const [r, g, b] = hexToRgb(hex).map((channel) => {
    const value = channel / 255

    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
  })
  const luminance = r * 0.2126 + g * 0.7152 + b * 0.0722

  return 1.05 / (luminance + 0.05) >= 3 ? hex : BLACK_BRANDING_COLOR
}
